import { Divider } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { useCurrentUserData } from "utils/currentUserHooks";
import ForwardToEmail from "./ForwardToEmail";
import MarkComplete from "./MarkComplete";

const fragment = gql(/* GraphQL */ `
  fragment SelectedEmailDefaultActions on ReceivedEmailMessage {
    emailMessageId
    ...SelectedEmailMarkCompletion
  }
`);

type Props = {
  data: FragmentType<typeof fragment> | null | undefined;
  isAdmin?: boolean;
};

export default function SelectedEmailDefaultActions({
  data,
  isAdmin = false,
}: Props) {
  const rem = getFragmentData(fragment, data);
  const user = useCurrentUserData();

  return (
    <>
      <MarkComplete data={rem} isAdmin={isAdmin} />

      <Divider my={4} />

      <ForwardToEmail
        defaultEmail={user?.email}
        emailId={rem?.emailMessageId}
      />
    </>
  );
}
